import { createAsyncThunk } from "@reduxjs/toolkit";
import server from "../middleware/interceptor";
export const getUserDetails = createAsyncThunk(
    "profile/profile" , 
    async (userId  : any ,  {rejectWithValue}) => {
      try{
        const response = await server.get(`/profile/profile/${userId}` , {
          headers : {
            "Content-Type" : "application/json" , 
          }
        }); 
        return response.data ;
      }catch(error : any) {
        return rejectWithValue(error.response.data || "Something went wrong")
      }
    }
  );
  export const updateUserDetails = createAsyncThunk(
    "profile/update-profile", 
    async (
    userDetails : any  , 
      { rejectWithValue }
    ) => {
      try {
        const response = await server.put(`/profile/update-profile/${userDetails.userId}`,
          {
            institution: userDetails.institution,
            grade : userDetails.grade,
            birth_date : userDetails.birth_date
          },
          {
            headers: {
              "Content-Type": "application/json", 
            },
          }
        );
  
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || "Something went wrong");
      }
    }
  );

  export const uploadProfileImage = createAsyncThunk(
    "profile/uploadProfileImage",
    async (
      { userId, imageFile }: { userId: any; imageFile: File },
      { rejectWithValue }
    ) => {
      try {
        const formData = new FormData();
        formData.append('file', imageFile); // Field name must be 'file'
  
        const response = await server.post(
          `/profile/students/profile-image?user_id=${userId}`, // user_id as query param
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
  
        return response;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || "Something went wrong");
      }
    }
  );

  export const sendQuery = createAsyncThunk(
    "profile/sendQuery",
    async (requestBody: any, { rejectWithValue }) => {
      try {
        const response = await server.post('/profile/students/submit-query', requestBody, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        const { data } = response;
        return data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || "Something went wrong");
      }
    }
  );
